/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Search_Link_TextInputs */

const en_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get quick answers about Brave Search`)
};

const id_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan jawaban cepat tentang Brave Penelusuran`)
};

const ms_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan jawapan pantas tentang Carian Brave`)
};

const ca_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtingues respostes ràpides sobre el Cercador de Brave`)
};

const cs_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získejte rychlé odpovědi o vyhledávači Brave`)
};

const da_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få hurtige svar om Brave Søgning`)
};

const de_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhalten Sie schnelle Antworten zu Brave Search.`)
};

const et_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saa kiireid vastuseid Brave'i otsingu kohta`)
};

const es_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén respuestas rápidas acerca de Brave Search`)
};

const fr_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir de l’aide concernant la recherche Brave`)
};

const hr_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dobite brze odgovore o tražilici Brave`)
};

const it_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi risposte rapide su Ricerca Brave`)
};

const lv_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saņemiet ātras atbildes par Brave meklēšanu`)
};

const lt_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaukite greitus atsakymus apie „Brave“ paiešką`)
};

const hu_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyors válaszok a Brave keresésről`)
};

const nl_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg meer informatie over Brave Search`)
};

const nb_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få kjappe svar om Brave Søk`)
};

const pl_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzyskaj szybkie odpowiedzi na temat Brave Search`)
};

const pt_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha respostas rápidas sobre a Pesquisa Brave`)
};

const ro_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obține răspunsuri rapide despre Brave Search`)
};

const sk_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Získajte rýchle odpovede o Vyhľadávaní Brave`)
};

const sl_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pridobite hitre odgovore o Brave Iskanju`)
};

const fi_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanki nopeasti vastauksia Brave Searchista`)
};

const sv_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få snabba svar om Brave Sök`)
};

const vi_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham khảo câu trả lời nhanh về Brave Tìm kiếm`)
};

const tr_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Arama hakkında hızlı yanıt alın`)
};

const el_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λάβετε γρήγορες απαντήσεις για το Brave Search`)
};

const bg_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получи бързи отговори за Brave Търсене`)
};

const ru_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите быстрые ответы о поиске Brave`)
};

const sr_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кратки одговори на питања о Brave претрази`)
};

const uk_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримайте швидкі відповіді про Пошук Brave`)
};

const ka_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მიიღეთ სწრაფი პასუხები Brave ძებნის შესახებ`)
};

const hi_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्रेव सर्च के बारे में जानकारी पाएं`)
};

const th_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับคำตอบอย่างรวดเร็วเกี่ยวกับ Brave Search`)
};

const ko_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 검색에 관한 자주 묻는 질문`)
};

const zh_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取有关 Brave 搜索的快速解答`)
};

const zh_tw_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲取有關 Brave 搜尋的快速解答`)
};

const ja_brave_search_link_text = /** @type {(inputs: Brave_Search_Link_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Searchに関するクイックアンサー`)
};

/**
* | output |
* | --- |
* | "Get quick answers about Brave Search" |
*
* @param {Brave_Search_Link_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_search_link_text = /** @type {((inputs?: Brave_Search_Link_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Search_Link_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_search_link_text(inputs)
	if (locale === "ms") return ms_brave_search_link_text(inputs)
	if (locale === "ca") return ca_brave_search_link_text(inputs)
	if (locale === "cs") return cs_brave_search_link_text(inputs)
	if (locale === "da") return da_brave_search_link_text(inputs)
	if (locale === "de") return de_brave_search_link_text(inputs)
	if (locale === "et") return et_brave_search_link_text(inputs)
	if (locale === "es") return es_brave_search_link_text(inputs)
	if (locale === "fr") return fr_brave_search_link_text(inputs)
	if (locale === "hr") return hr_brave_search_link_text(inputs)
	if (locale === "it") return it_brave_search_link_text(inputs)
	if (locale === "lv") return lv_brave_search_link_text(inputs)
	if (locale === "lt") return lt_brave_search_link_text(inputs)
	if (locale === "hu") return hu_brave_search_link_text(inputs)
	if (locale === "nl") return nl_brave_search_link_text(inputs)
	if (locale === "nb") return nb_brave_search_link_text(inputs)
	if (locale === "pl") return pl_brave_search_link_text(inputs)
	if (locale === "pt") return pt_brave_search_link_text(inputs)
	if (locale === "ro") return ro_brave_search_link_text(inputs)
	if (locale === "sk") return sk_brave_search_link_text(inputs)
	if (locale === "sl") return sl_brave_search_link_text(inputs)
	if (locale === "fi") return fi_brave_search_link_text(inputs)
	if (locale === "sv") return sv_brave_search_link_text(inputs)
	if (locale === "vi") return vi_brave_search_link_text(inputs)
	if (locale === "tr") return tr_brave_search_link_text(inputs)
	if (locale === "el") return el_brave_search_link_text(inputs)
	if (locale === "bg") return bg_brave_search_link_text(inputs)
	if (locale === "ru") return ru_brave_search_link_text(inputs)
	if (locale === "sr") return sr_brave_search_link_text(inputs)
	if (locale === "uk") return uk_brave_search_link_text(inputs)
	if (locale === "ka") return ka_brave_search_link_text(inputs)
	if (locale === "hi") return hi_brave_search_link_text(inputs)
	if (locale === "th") return th_brave_search_link_text(inputs)
	if (locale === "ko") return ko_brave_search_link_text(inputs)
	if (locale === "zh") return zh_brave_search_link_text(inputs)
	if (locale === "zh-tw") return zh_tw_brave_search_link_text(inputs)
	if (locale === "ja") return ja_brave_search_link_text(inputs)
	return en_brave_search_link_text(inputs)
});